(function(){
"use strict";

angular.module("swapick")
.factory('Preferences', Preferences);

function Preferences(baseServerUrl, store){
    var svc = {}

    svc.getCurrentShopId = () => store.get('currentShopId');
    svc.setCurrentShopId = (shopId) => store.set('currentShopId', shopId);

    svc.clearPreferences = () => {
        store.remove('currentShopId');
    }


    return svc;    
}



})();


// WEBPACK FOOTER //
// ./src/services/preferences-service.js